import React, { useEffect, useState, useRef } from 'react';
import { CSVLink } from 'react-csv';
import DataTable from 'react-data-table-component';
import {
    GET_DMT_TRANSACTION_DETAIL_REPORT,
    GET_DMT_TRANSACTION_INQUIRY,
    POST_DMT_TRANSACTION_UPDATE
} from './../../../Utils/appConstants';

import { Select, Modal, Divider, DatePicker, Tooltip, Space, Tag } from 'antd';
import {
    FilterOutlined,
    SearchOutlined,
    ClearOutlined,
    DownloadOutlined,
} from '@ant-design/icons';
import {
    channelStatus,
    dmtDetailStatus,
    dmtDetailStatusInArray,
    dmtDetailStatusInNewArray,
    dmtModeInArray
} from './../../../Utils/Common';
import { getRequest, postRequest } from './../../../Utils/AppApi';
import { useHistory } from "react-router-dom";
import PropagateLoader from "react-spinners/PropagateLoader";
import { getUTCToLocalDateTimeFormat, toDayDate, queryDate } from '../../../Utils/function';
import { toast } from 'react-toastify';

/* ============================================================
   MODERN STYLES (scoped) — identical to AePS / FundTransfer
============================================================ */
const reportStyles = `
.aeps-page {
    padding: 16px 24px 40px;
    background: #f5f7fb;
    min-height: calc(100vh - 60px);
}
.aeps-page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 18px;
    flex-wrap: wrap;
    gap: 12px;
}
.aeps-page-title {
    font-size: 22px;
    font-weight: 700;
    color: #1f2a44;
    margin: 0;
    letter-spacing: 0.2px;
}
.aeps-page-title span { color: #e5484d; }
.aeps-page-subtitle {
    font-size: 13px;
    color: #6b7280;
    margin: 2px 0 0;
}

.aeps-card {
    background: #ffffff;
    border-radius: 14px;
    box-shadow: 0 1px 2px rgba(16,24,40,.04), 0 4px 16px rgba(16,24,40,.06);
    border: 1px solid #eef0f4;
    overflow: hidden;
}
.aeps-card + .aeps-card { margin-top: 18px; }

.aeps-card-head {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 14px 20px;
    border-bottom: 1px solid #f0f2f6;
    background: linear-gradient(180deg, #fbfcfe 0%, #ffffff 100%);
}
.aeps-card-head-title {
    font-size: 13px;
    font-weight: 600;
    color: #344054;
    text-transform: uppercase;
    letter-spacing: .6px;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;
}
.aeps-card-head-title .anticon {
    color: #5851D2;
    font-size: 14px;
}

.aeps-filter-body { padding: 18px 20px 20px; }

.aeps-filter-grid {
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    gap: 14px 16px;
    align-items: end;
}

.aeps-field { display: flex; flex-direction: column; min-width: 0; }
.aeps-field label {
    font-size: 11.5px;
    font-weight: 600;
    color: #667085;
    text-transform: uppercase;
    letter-spacing: .4px;
    margin-bottom: 6px;
}

/* ⭐ Fields that span 2 grid columns on desktop */
.aeps-field-span-2 { grid-column: span 2; }

.aeps-field .ant-picker,
.aeps-field .ant-select,
.aeps-field .aeps-input {
    width: 100%;
    height: 40px;
    border-radius: 10px;
    border: 1px solid #e4e7ec;
    background: #fff;
    transition: border-color .15s, box-shadow .15s;
    font-size: 13.5px;
}
.aeps-field .ant-picker { padding: 0 11px; }
.aeps-field .ant-picker input { font-size: 13.5px; }
.aeps-field .ant-select .ant-select-selector {
    height: 40px !important;
    border-radius: 10px !important;
    border: 1px solid #e4e7ec !important;
    padding: 0 11px !important;
}
.aeps-field .ant-select-single .ant-select-selector .ant-select-selection-item,
.aeps-field .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
    line-height: 38px !important;
    font-size: 13.5px;
}
.aeps-field .ant-picker:hover,
.aeps-field .ant-select:hover .ant-select-selector,
.aeps-field .aeps-input:hover { border-color: #c7cbd3 !important; }
.aeps-field .ant-picker-focused,
.aeps-field .ant-select-focused .ant-select-selector,
.aeps-field .aeps-input:focus {
    border-color: #5851D2 !important;
    box-shadow: 0 0 0 3px rgba(88,81,210,.12) !important;
    outline: none;
}

.aeps-input {
    padding: 0 12px;
    color: #101828;
    outline: none;
}
.aeps-input::placeholder { color: #98a2b3; }

/* ⭐ Actions now live IN row 2, spanning 2 columns (was full-width row 3) */
.aeps-filter-grid .aeps-actions {
    grid-column: span 2;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-items: flex-end;
    gap: 10px;
    min-height: 40px;
}

/* ── Buttons ─────────────────────────────────────────── */
.aeps-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    height: 40px;
    padding: 0 20px;
    border-radius: 10px;
    border: 1px solid transparent;
    font-size: 13.5px;
    font-weight: 600;
    cursor: pointer;
    transition: transform .08s, box-shadow .15s, background .15s, border-color .15s;
    white-space: nowrap;
}
.aeps-btn:active { transform: translateY(1px); }
.aeps-btn-primary {
    background: linear-gradient(180deg, #6b64e0 0%, #5851D2 100%);
    color: #fff;
    box-shadow: 0 2px 6px rgba(88,81,210,.35);
}
.aeps-btn-primary:hover { box-shadow: 0 4px 12px rgba(88,81,210,.45); }
.aeps-btn-ghost {
    background: #ffffff;
    color: #475467;
    border-color: #e4e7ec;
}
.aeps-btn-ghost:hover { background: #f9fafb; border-color: #cfd4dc; }
.aeps-btn-success {
    background: #ffffff;
    color: #0e9384;
    border-color: #b7e4dd;
}
.aeps-btn-success:hover { background: #f0fdfa; border-color: #0e9384; }

/* ── Table ───────────────────────────────────────────── */
.aeps-table-wrap { padding: 4px 6px 10px; }
.aeps-table-wrap .rdt_TableHeadRow {
    background: #f9fafb !important;
    border-bottom: 1px solid #eef0f4 !important;
    min-height: 46px !important;
}
.aeps-table-wrap .rdt_TableCol {
    font-size: 11.5px !important;
    font-weight: 700 !important;
    color: #475467 !important;
    text-transform: uppercase !important;
    letter-spacing: .4px !important;
}
.aeps-table-wrap .rdt_TableRow {
    border-bottom: 1px solid #f2f4f7 !important;
    min-height: 52px !important;
    transition: background .15s;
}
.aeps-table-wrap .rdt_TableRow:hover { background: #fafbff !important; }
.aeps-table-wrap .rdt_TableCell { font-size: 13px !important; color: #344054 !important; }
.aeps-table-wrap .rdt_Pagination {
    border-top: 1px solid #eef0f4 !important;
    background: #fff !important;
    min-height: 52px !important;
}

/* Medium desktops (1024-1400px): tighten buttons so they don't wrap in 2 cols */
@media (min-width: 1024px) and (max-width: 1400px) {
    .aeps-filter-grid .aeps-actions .aeps-btn {
        padding: 0 12px;
        font-size: 12.5px;
    }
    .aeps-filter-grid .aeps-actions { gap: 6px; }
}

/* Below 1024px: auto-fit grid, actions take full width, span-2 fields reset */
@media (max-width: 1023px) {
    .aeps-filter-grid {
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    }
    .aeps-field-span-2 { grid-column: auto; }
    .aeps-filter-grid .aeps-actions {
        grid-column: 1 / -1;
        margin-top: 6px;
        padding-top: 16px;
        border-top: 1px dashed #eef0f4;
    }
}

@media (max-width: 640px) {
    .aeps-page { padding: 12px; }
    .aeps-filter-grid .aeps-actions { justify-content: center; }
    .aeps-filter-grid .aeps-actions .aeps-btn {
        flex: 1 1 auto;
        justify-content: center;
    }
}
`;

/* ============================================================
   API PROVIDER HELPER
============================================================ */
const getApiProvider = (row) => {
    const txId = String(row?.transactionId || row?.dmttransactions?.client_ref_id || '');
    if (/^IM/i.test(txId)) return 'IMW';
    if (/^(SI|SN|SJ)/i.test(txId)) return 'IP';
    return '-';
};

/* ============================================================ */

function DmtDetailReport(props) {

    const history = useHistory();
    const csvLink = useRef();
    const limit = 10;
    const dateFormat = 'DD-MM-YYYY';

    const [searchUserId, setSearchUserId] = useState('');
    const [searchAccountNumber, setSearchAccountNumber] = useState('');
    const [searchTransId, setSearchTransId] = useState('');
    const [searchCustomerId, setSearchCustomerId] = useState('');
    const [searchStatus, setSearchStatus] = useState(null);
    const [searchMode, setSearchMode] = useState(null);

    const [endDate, setEndDate] = useState(toDayDate());
    const [startDate, setStartDate] = useState(toDayDate());
    const [getData, setData] = useState({ docs: [] });
    const [getCsvData, setCsvData] = useState([]);
    const [getTotalRecord, setTotalRecord] = useState(0);
    const [page, setPage] = useState(1);
    const [isLimit, setLimit] = useState(limit);
    const [userId, setUserId] = useState(props.userId);
    const [isLoading, setLoading] = useState(false);
    const [isEditModal, setEditModal] = useState(false);

    const [isSelectedData, setSelectedData] = useState(null);
    const [editStatus, setEditStatus] = useState(null);
    const [editTid, setEditTid] = useState(null);

    const [fetchTrigger, setFetchTrigger] = useState(0);
    const [tableResetKey, setTableResetKey] = useState(0);

    // ============================================================
    //  COLUMNS
    // ============================================================
    const columns = [
        {
            name: 'Date Time',
            cell: row => getUTCToLocalDateTimeFormat(row.dmttransactions.createdAt),
            width: '190px',
        },
        {
            name: 'Trans ID',
            selector: row => (
                <Tooltip placement="bottom" className="pointer" title={row.dmttransactions && row.dmttransactions.client_ref_id}>
                    <u>{row.dmttransactions && row.dmttransactions.client_ref_id}</u>
                </Tooltip>
            ),
            width: '180px',
        },
        {
            name: 'Amount',
            selector: row => `${row.amount} ${row.dmttransactions.currency}`,
            width: '110px',
        },
        {
            name: 'Status',
            selector: row => dmtDetailStatus(row.tx_status),
            width: '180px',
        },
        {
            name: 'TID',
            selector: row => <Tooltip placement="bottom" title={row.tid}>{row.tid}</Tooltip>,
            width: '200px',
        },
        {
            name: 'Mode',
            selector: row => channelStatus(row.dmttransactions.channel),
            width: '110px',
        },
        {
            name: 'API Provider',
            selector: row => getApiProvider(row),
            width: '130px',
            center: true,
        },
        {
            name: 'Sub Trans ID',
            selector: row => (
                <Tooltip placement="bottom" className="pointer" title={row.transactionId}>
                    <u>{row.transactionId}</u>
                </Tooltip>
            ),
            width: '180px',
        },
        {
            name: 'Customer ID',
            selector: row => <Tooltip placement="bottom" title={row.customer_id}>{row.customer_id}</Tooltip>,
            width: '130px',
        },
        {
            name: 'Partner ID',
            selector: row => <Tooltip placement="bottom" title={row.users && row.users.username}>{row.users && row.users.username}</Tooltip>,
            width: '130px',
        },
        {
            name: 'Bank RRN',
            selector: row => <Tooltip placement="bottom" title={row.bank_ref_num}>{row.bank_ref_num}</Tooltip>,
            width: '160px',
        },
        {
            name: 'IFSC Code',
            selector: row => row.dmttransactions.ifsccode,
            width: '120px',
        },
        {
            name: 'Account Number',
            selector: row => <Tooltip placement="bottom" title={row.dmttransactions.accountNumber}>{row.dmttransactions.accountNumber}</Tooltip>,
            width: '170px',
        },
        {
            name: 'Bene Name',
            selector: row => (
                <Tooltip
                    placement="bottom"
                    title={row.baneData ? row.baneData.beneName : (row.baneData1) ? row.baneData1.beneName : ''}
                >
                    {row.baneData ? row.baneData.beneName : (row.baneData1) ? row.baneData1.beneName : ''}
                </Tooltip>
            ),
            width: '150px',
        },
        {
            name: 'Reason',
            selector: row => <Tooltip placement="bottom" title={row.reason}>{row.reason}</Tooltip>,
            width: '180px',
        },
    ];

    // ============================================================
    //  HELPERS
    // ============================================================
    const objectToQueryString = (obj) => {
        const str = [];
        for (const p in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, p)) {
                str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
            }
        }
        return str.join('&');
    };

    // ============================================================
    //  FETCH
    // ============================================================
    const getDataReports = () => {
        const params = { page, limit: isLimit };

        if (startDate && endDate) {
            params.startDate = queryDate(startDate);
            params.endDate = queryDate(endDate);
        }
        if (props.userId) {
            params.userId = userId || props.userId;
        }
        params.searchAccountNumber = searchAccountNumber || '';
        params.searchCustomerId = searchCustomerId || '';
        params.searchTransId = searchTransId || '';
        params.searchUserId = searchUserId || '';
        params.searchStatus = searchStatus || '';
        params.searchMode = searchMode || '';

        setLoading(true);
        const queryString = objectToQueryString(params);
        getRequest(`${GET_DMT_TRANSACTION_DETAIL_REPORT}?${queryString}`, history)
            .then((response) => {
                if (response.success === true && response.data) {
                    setData(response.data);
                    setTotalRecord(response.data.totalDocs || 0);
                    if (typeof response.data.page === 'number') setPage(response.data.page);
                } else {
                    setData({ docs: [] });
                    setTotalRecord(0);
                }
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setData({ docs: [] });
                setTotalRecord(0);
                setLoading(false);
            });
    };

    useEffect(() => {
        getDataReports();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchTrigger]);

    // ============================================================
    //  CSV EXPORT
    // ============================================================
    const getCSVDataList = () => {
        const params = { exportsCsv: true };
        if (startDate && endDate) {
            params.startDate = queryDate(startDate);
            params.endDate = queryDate(endDate);
        }
        if (props.userId) {
            params.userId = userId || props.userId;
        }
        params.searchAccountNumber = searchAccountNumber || '';
        params.searchCustomerId = searchCustomerId || '';
        params.searchTransId = searchTransId || '';
        params.searchUserId = searchUserId || '';
        params.searchStatus = searchStatus || '';
        params.searchMode = searchMode || '';

        const queryString = objectToQueryString(params);
        getRequest(`${GET_DMT_TRANSACTION_DETAIL_REPORT}?${queryString}`, history)
            .then((response) => {
                if (response.success === true) {
                    const csvdataRecord = (response.data || []).map((e) => ({
                        'Date Time': getUTCToLocalDateTimeFormat(e.dmttransactions.createdAt),
                        'Trans ID': e.dmttransactions.client_ref_id,
                        'Amount': e.amount,
                        'Status': e.txstatus_desc,
                        'TID': e.tid,
                        'Mode': channelStatus(e.dmttransactions.channel),
                        'API Provider': getApiProvider(e),
                        'Sub Trans ID': e.transactionId,
                        'Customer ID': e.customer_id,
                        'Partner ID': e.users && e.users.username,
                        'Bank RRN': e.bank_ref_num,
                        'IFSC Code': e.dmttransactions.ifsccode,
                        'Account Number': e.dmttransactions.accountNumber,
                        'Bene Name': e.baneData ? e.baneData.beneName : (e.baneData1) ? e.baneData1.beneName : '',
                        'Reason': e.reason,
                    }));
                    setCsvData(csvdataRecord);
                    setTimeout(() => {
                        if (csvLink.current && csvLink.current.link) {
                            csvLink.current.link.click();
                        }
                    }, 1000);
                } else {
                    setCsvData([]);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    // ============================================================
    //  EDIT / INQUIRY (preserved)
    // ============================================================
    const handleEdit = (data) => {
        setSelectedData(data);
        setEditModal(true);
        setEditStatus(data.tx_status);
        setEditTid(data.tid);
    };

    const transactionInquiry = (data) => {
        setLoading(true);
        const payload = { transactionId: data.transactionId };
        const URL = GET_DMT_TRANSACTION_INQUIRY;
        postRequest(`${URL}`, payload, history)
            .then((response) => {
                if (response.success === true) {
                    toast.success(response.message);
                    getDataReports();
                } else {
                    toast.error(response.message);
                }
                setLoading(false);
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
            });
    };

    const handleSubmit = () => {
        const payload = {
            id: isSelectedData._id,
            status: editStatus,
            tid: editTid,
        };
        postRequest(`${POST_DMT_TRANSACTION_UPDATE}`, payload, history)
            .then((response) => {
                if (response.success === true) {
                    setEditModal(false);
                    toast.success(response.message);
                } else {
                    toast.error(response.message);
                }
                setLoading(false);
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
            });
    };

    // ============================================================
    //  HANDLERS
    // ============================================================
    const resetToFirstPageAndFetch = () => {
        setPage(1);
        setTableResetKey((k) => k + 1);
        setFetchTrigger((k) => k + 1);
    };

    const handlePageChange = (newPage /*, size */) => {
        setPage(newPage);
        setFetchTrigger((k) => k + 1);
    };

    const handleRowsPerPageChange = (newLimit) => {
        setLimit(newLimit);
        resetToFirstPageAndFetch();
    };

    const handleSearch = () => resetToFirstPageAndFetch();

    const handleClear = () => {
        setStartDate(toDayDate());
        setEndDate(toDayDate());
        setSearchAccountNumber('');
        setSearchTransId('');
        setSearchCustomerId('');
        setSearchUserId('');
        setSearchStatus(null);
        setSearchMode(null);
        resetToFirstPageAndFetch();
    };

    const onChangeStartDate = (date) => setStartDate(date);
    const onChangeEndDate = (date) => setEndDate(date);
    const onChangeType = (value) => setSearchStatus(value);
    const onChangeTypeMode = (value) => setSearchMode(value);
    const onChangeEditStatus = (value) => setEditStatus(value);

    useEffect(() => {
        if (props.userId) setUserId(props.userId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // ============================================================
    //  RENDER
    // ============================================================
    return (
        <div className="aeps-page">
            <style>{reportStyles}</style>

            {/* <div className="aeps-page-header">
                <div>
                    <h1 className="aeps-page-title">
                        Money Transfer <span>Detail Report</span>
                    </h1>
                    <p className="aeps-page-subtitle">
                        Search, filter, and export DMT transaction details
                    </p>
                </div>
            </div> */}

            {/* ─── Filters card — 2 rows ──────────────────────── */}
            <div className="aeps-card">
              
                <div className="aeps-filter-body">
                    <div className="aeps-filter-grid">
                        {/* ════════ ROW 1 — 6 fields, one per column ════════ */}
                        <div className="aeps-field">
                            <label>From Date</label>
                            <DatePicker
                                value={startDate}
                                format={dateFormat}
                                onChange={onChangeStartDate}
                                placeholder="From date"
                            />
                        </div>

                        <div className="aeps-field">
                            <label>To Date</label>
                            <DatePicker
                                value={endDate}
                                format={dateFormat}
                                onChange={onChangeEndDate}
                                placeholder="To date"
                            />
                        </div>

                        <div className="aeps-field">
                            <label>User ID</label>
                            <input
                                type="text"
                                className="aeps-input"
                                placeholder="Enter User ID"
                                onChange={(e) => setSearchUserId(e.target.value)}
                                value={searchUserId}
                            />
                        </div>

                        <div className="aeps-field">
                            <label>Trans ID</label>
                            <input
                                type="text"
                                className="aeps-input"
                                placeholder="Enter Trans ID"
                                onChange={(e) => setSearchTransId(e.target.value)}
                                value={searchTransId}
                            />
                        </div>

                        <div className="aeps-field">
                            <label>A/C Number</label>
                            <input
                                type="text"
                                className="aeps-input"
                                placeholder="Enter A/C number"
                                onChange={(e) => setSearchAccountNumber(e.target.value)}
                                value={searchAccountNumber}
                            />
                        </div>

                        <div className="aeps-field">
                            <label>Customer ID</label>
                            <input
                                type="text"
                                className="aeps-input"
                                placeholder="Enter Customer ID"
                                onChange={(e) => setSearchCustomerId(e.target.value)}
                                value={searchCustomerId}
                            />
                        </div>

                        {/* ════════ ROW 2 — Mode(2) + Status(2) + Actions(2) ════════ */}
                        <div className="aeps-field aeps-field-span-2">
                            <label>Mode</label>
                            <Select
                                options={dmtModeInArray}
                                className="normal-light"
                                classNamePrefix="select"
                                placeholder="Select mode"
                                name="mode"
                                onChange={onChangeTypeMode}
                                value={searchMode || undefined}
                                allowClear
                            />
                        </div>

                        <div className="aeps-field aeps-field-span-2">
                            <label>Status</label>
                            <Select
                                options={dmtDetailStatusInNewArray}
                                className="normal-light"
                                classNamePrefix="select"
                                placeholder="Select status"
                                name="status"
                                onChange={onChangeType}
                                value={searchStatus || undefined}
                                allowClear
                            />
                        </div>

                        {/* Actions live in row 2, right-aligned, span 2 cols */}
                        <div className="aeps-actions">
                            <button type="button" className="aeps-btn aeps-btn-ghost" onClick={handleClear}>
                                <ClearOutlined /> Clear
                            </button>

                            <button type="button" className="aeps-btn aeps-btn-success" onClick={getCSVDataList}>
                                <DownloadOutlined /> Export CSV
                            </button>

                            <button type="button" className="aeps-btn aeps-btn-primary" onClick={handleSearch}>
                                <SearchOutlined /> Search
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* ─── Table card ─────────────────────────────────── */}
            <div className="aeps-card">
                <div className="aeps-table-wrap">
                    <DataTable
                        key={tableResetKey}
                        title=""
                        columns={columns}
                        data={getData.docs || []}
                        highlightOnHover
                        pagination
                        paginationServer
                        paginationTotalRows={getTotalRecord}
                        paginationDefaultPage={page}
                        paginationPerPage={isLimit}
                        progressPending={isLoading}
                        progressComponent={
                            <div className="text-center py-4">
                                <PropagateLoader color="#5851D2" size={20} />
                            </div>
                        }
                        onChangeRowsPerPage={handleRowsPerPageChange}
                        onChangePage={handlePageChange}
                        noDataComponent={
                            <div style={{ padding: '40px 20px', color: '#98a2b3', fontSize: 13 }}>
                                No records found for the selected filters.
                            </div>
                        }
                    />
                </div>
            </div>

            <CSVLink
                data={getCsvData}
                filename="dmtDetailList"
                className="hidden"
                ref={csvLink}
                target="_blank"
                style={{ display: 'none' }}
            />

            {isEditModal && (
                <Modal
                    title="Edit Details"
                    width={600}
                    open={isEditModal}
                    onCancel={() => setEditModal(false)}
                    footer={false}
                >
                    {isSelectedData ? (
                        <ul>
                            <li>
                                <strong>Name</strong> :{' '}
                                {isSelectedData.baneData1 && isSelectedData.baneData1.beneName
                                    ? isSelectedData.baneData1.beneName
                                    : (isSelectedData.baneData && isSelectedData.baneData.beneName)}
                            </li>
                            <li><strong>A/C</strong> : {isSelectedData.dmttransactions.accountNumber}</li>
                            <li><strong>IFSC</strong> : {isSelectedData.dmttransactions.ifsccode}</li>
                            <li><strong>Amount</strong> : {isSelectedData.amount}</li>
                            <li><strong>Transaction ID</strong> : {isSelectedData.transactionId}</li>
                            <li className="d-flex">
                                <strong>Status </strong> : {dmtDetailStatus(isSelectedData.tx_status)}
                            </li>
                            <Divider />
                        </ul>
                    ) : ''}
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <label>Status: </label>
                            <Select
                                options={dmtDetailStatusInArray}
                                className="normal-light w-100"
                                classNamePrefix="select"
                                placeholder="-- Status --"
                                name="status"
                                onChange={onChangeEditStatus}
                            />
                        </div>
                        <div className="col-md-12 form-group">
                            <label>TID: </label>
                            <input
                                type="text"
                                className="form-control"
                                maxLength={25}
                                name="tid"
                                value={editTid || ''}
                                onChange={(e) => setEditTid(e.target.value)}
                            />
                        </div>
                        <div className="col-md-12 d-flex">
                            <div className="mr-2">
                                <button className="btn btn-success" onClick={handleSubmit}>Submit</button>
                            </div>
                            <div className="mr-2">
                                <button className="btn btn-default" onClick={() => setEditModal(false)}>Close</button>
                            </div>
                        </div>
                    </div>
                </Modal>
            )}
        </div>
    );
}

export default DmtDetailReport;